import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';

export default function AtualizarRelatorio() {
  const [atualizandoRelatorio, setAtualizandoRelatorio] = useState(false);
  const [atualizandoMensuracao, setAtualizandoMensuracao] = useState(false);
  const [atualizandoTaxaSucesso, setAtualizandoTaxaSucesso] = useState(false);
  const [atualizandoAntifraude, setAtualizandoAntifraude] = useState(false);
  const [atualizandoComprasPontuacao, setAtualizandoComprasPontuacao] =
    useState(false);
  const [mes, setMes] = useState('');
  const [ano, setAno] = useState('');

  // try/finally garante que o botão sai de "ATUALIZANDO..." mesmo se a
  // requisição falhar ou o servidor demorar/cair
  const gerarRelatorio = async (url, setAtualizando) => {
    setAtualizando(true);
    try {
      const resultado = await api.get(url);

      if (resultado && resultado.data && resultado.data.mensagem) {
        const exibirToast =
          resultado.data.success === false ? toast.error : toast.success;
        exibirToast(resultado.data.mensagem, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
      }
    } finally {
      setAtualizando(false);
    }
  };

  const atualizarRelatorio = async (e) => {
    e.preventDefault();
    await gerarRelatorio('/api/relatorio/gerar', setAtualizandoRelatorio);
  };

  const atualizarComprasPontuacao = async (e) => {
    e.preventDefault();
    await gerarRelatorio(
      `/api/compras-pontuacao/gerar?ano=${ano}&mes=${mes}`,
      setAtualizandoComprasPontuacao
    );
  };

  const atualizarTaxaSucesso = async (e) => {
    e.preventDefault();
    await gerarRelatorio(
      `/api/taxa-sucesso/gerar?ano=${ano}&mes=${mes}`,
      setAtualizandoTaxaSucesso
    );
  };

  const atualizarAntifraude = async (e) => {
    e.preventDefault();
    await gerarRelatorio('/api/antifraude/gerar', setAtualizandoAntifraude);
  };

  const atualizarMensuracao = async (e) => {
    e.preventDefault();
    await gerarRelatorio('/api/mensuracao/gerar', setAtualizandoMensuracao);
  };

  return (
    <Container fluid>
      <div>
        <h4 className="pt-3 pb-3 f-black">Atualizar Relatórios</h4>
        <hr className="hr-loja mt-0 mb-5" />
      </div>
      <div className="d-flex flex-column align-items-center">
        <form className="form">
          <Row>
            <Col xs={6}>
              <label htmlFor="ano">Ano</label>
              <input
                id="ano"
                name="ano"
                type="number"
                placeholder="Ano"
                className="w-100"
                value={ano}
                onChange={(e) => setAno(e.target.value)}
              ></input>
            </Col>
            <Col xs={6}>
              <label htmlFor="mes">Mês</label>
              <input
                id="mes"
                name="mes"
                type="number"
                placeholder="Mês"
                value={mes}
                className="w-100"
                onChange={(e) => setMes(Number(e.target.value))}
              ></input>
            </Col>
          </Row>
          {atualizandoRelatorio ? (
            <button disabled className="btn-primario mb-3" type="button">
              ATUALIZANDO...
            </button>
          ) : (
            <button
              className="btn-primario mb-3"
              type="button"
              onClick={atualizarRelatorio}
            >
              ATUALIZAR RELATÓRIO
            </button>
          )}
          {atualizandoComprasPontuacao ? (
            <button disabled className="btn-primario mb-3" type="button">
              ATUALIZANDO...
            </button>
          ) : (
            <button
              className="btn-primario mb-3"
              type="button"
              onClick={atualizarComprasPontuacao}
            >
              ATUALIZAR COMPRAS X PONTUAÇÃO
            </button>
          )}
          {atualizandoTaxaSucesso ? (
            <button disabled className="btn-primario mb-3" type="button">
              ATUALIZANDO...
            </button>
          ) : (
            <button
              className="btn-primario mb-3"
              type="button"
              onClick={atualizarTaxaSucesso}
            >
              ATUALIZAR TAXA DE SUCESSO
            </button>
          )}
          {atualizandoAntifraude ? (
            <button disabled className="btn-primario mb-3" type="button">
              ATUALIZANDO...
            </button>
          ) : (
            <button
              className="btn-primario mb-3"
              type="button"
              onClick={atualizarAntifraude}
            >
              ATUALIZAR ANTIFRAUDE
            </button>
          )}
          {atualizandoMensuracao ? (
            <button disabled className="btn-primario mb-3" type="button">
              ATUALIZANDO...
            </button>
          ) : (
            <button
              className="btn-primario mb-3"
              type="button"
              onClick={atualizarMensuracao}
            >
              ATUALIZAR MENSURAÇÃO
            </button>
          )}
        </form>
      </div>
    </Container>
  );
}
